import { theme } from '@approvalmax/theme';
import { BaseItem, BodyCellProps, Table } from '@approvalmax/ui/src/components';
import { ReactElement } from 'react';
import styled from 'styled-components';

export const CellStyled = styled(Table.Cell)`
    color: ${theme.color.midnight70};
    background-color: ${theme.color.midnight20};
` as <Item extends BaseItem>(props: BodyCellProps<Item>) => ReactElement;
